export default "__VITE_ASSET__Ct5OqC9T__"